module.exports = __webpack_public_path__ + "img/Evening Primrose Oil.9495261f.jpg";